export default "__VITE_ASSET__DglmVqd8__"